// Internal modules
import { apolloClient } from '@/lib/apollo';
import { COOKIE_BANNER_QUERY } from '../queries';

export const queryCookieBanner = () => {
  /**
   * Why are we setting the `fetchPolicy` to `'network-only'`?
   *
   * The banner result depends on current cookies. If the user has accepted
   * the cookies before changing locales, maybe they just did it out of habit
   * to get rid of the thing, then we won't show the banner again, even though
   * the country/language is changing. Additionally, the content on the banner
   * can change based on banner policy (CCPA, GDPR, etc) and language.
   * Therefore, we don't ever want to rely on the Apollo cache but instead use
   * the `commonutils-client` backend module as the source of truth.
   */
  return apolloClient
    .query({
      context: {
        isBatchedQuery: true,
      },
      fetchPolicy: 'network-only',
      query: COOKIE_BANNER_QUERY,
    })
    .then(({ data }) => data.cookieBanner);
};
